import React from 'react'
import './mainheading.scss';
import { Row, Col } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { ShareIcon } from '../../../icon/icons';

const MainHeading = ({ showshare = true, title }) => {
    return (
        <div className='about_us_heading'>
            <Row>
                <Col sm={12} md={10} lg={10} xl={10}>
                    <h1>{title}</h1>
                </Col>
                <Col sm={12} md={2} lg={2} xl={2}>
                    {showshare &&
                        <div className='share'>
                            <Dropdown>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                    <ShareIcon />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    }
                </Col>
            </Row>
        </div>
    )
}

export default MainHeading